const styles = {
    loadingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
    },
    pageHeader: {
        backgroundColor: "#f5f5f5",
        padding: 4,
        borderRadius: 2,
        marginBottom: 2,
    },
    card: {
        borderRadius: 2,
        width: "100%",
    },
    dataGridPaper: {
        padding: 2,
        borderRadius: 2,
    },
    dialogTextField: {
        marginBottom: 2,
    },
};

export default styles;
